import { z } from 'zod';

export const VersionResponseSchema = z.object({
  approvedAt: z.string(),
  approvedBy: z.string(),
  canBeDeleted: z.boolean(),
  canBeDuplicated: z.boolean(),
  createdAt: z.string(),
  description: z.string(),
  id: z.number(),
  isCurrent: z.boolean(),
  lastUpdate: z.string(),
  mediaPlan: z.number(),
  name: z.string(),
});
